import { createSlice } from "@reduxjs/toolkit";
import {
  workerListAction,
  workerDetailAction,
  workerCreateAction,
  workerEditAction,
  multiWorkerCreateAction,
  workerDailyUsageAction,
  workerResetPasswordAction,
  resetWorkerAction,
} from "../Action/workerAction";

const initialState = {
  workers: {},
  workerDetail: {},
  workerDailyUsage: {},
  workerCreateStatus: "idle",
  workerEditStatus: "idle",
  multiWorkerCreateStatus: "idle",
  workerResetStatus: "idle",
};

const workerSlice = createSlice({
  name: "worker",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetWorkerAction, (state) => {
        state.workerDetail = {};
      })
      .addCase(workerListAction.fulfilled, (state, action) => {
        state.workers = action?.payload?.data;
      })
      .addCase(workerDetailAction.fulfilled, (state, action) => {
        state.workerDetail = action?.payload?.data;
      })
      .addCase(workerCreateAction.fulfilled, (state) => {
        state.workerCreateStatus = "succeeded";
      })
      .addCase(workerEditAction.fulfilled, (state) => {
        state.workerEditStatus = "succeeded";
      })
      .addCase(multiWorkerCreateAction.fulfilled, (state) => {
        state.multiWorkerCreateStatus = "succeeded";
      })
      .addCase(workerDailyUsageAction.fulfilled, (state, action) => {
        state.workerDailyUsage = action?.payload?.data;
      })
      .addCase(workerResetPasswordAction.fulfilled, (state, action) => {
        state.workerResetStatus = action?.payload?.data;
      });
  },
});

export default workerSlice.reducer;
